export const feedback = {
  signer: {
    is_user: true,
    has_pendencies: true,
  },
};
